<template>
  <el-dialog class="mainDialog" title="提交交收" center :visible.sync="dialogVisible" width="400px">
    <div class="inputWrap">
      <div class="itemSearch">
        <span class="title">交易品种</span>
        <el-select
          v-model="chooseGood.commodityId"
          popper-class="_formSelect"
          class="searchSelect"
          placeholder="请选择交易品种"
          :disabled="type==2"
          @change="getCanApplyNum"
        >
          <el-option
            v-for="item in commodityOptions"
            :key="item.symbolId"
            :label="item.symbol"
            :value="item.symbolId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="itemSearch">
        <span class="title">交易方向</span>
        <el-select
          popper-class="_formSelect"
          v-model="chooseGood.bsFlag"
          class="searchSelect"
          :disabled="type==2"
          placeholder="请选择交易方向"
          @change="getCanApplyNum"
        >
          <el-option
            v-for="item in bsFlagsOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="itemSearch">
        <span class="title">申请数量</span>
        <div class="inputsWrap">
          <el-input v-model.number="chooseGood.quantity" type="number" :placeholder="'可申请数量'+ maxApplyNum" @input="changeQuantity($event)"></el-input>
        </div>
      </div>
      <div class="itemSearch">
        <span class="title">收货人</span>
        <div class="inputsWrap">
          <el-input v-model="chooseGood.name" placeholder="请输入收货人"></el-input>
        </div>
      </div>
      <div class="itemSearch">
        <span class="title">联系电话</span>
        <div class="inputsWrap">
          <el-input v-model="chooseGood.cellphone" maxlength="11" placeholder="请输入联系电话"></el-input>
        </div>
      </div>
      <div class="itemSearch">
        <span class="title">收货地址</span>
        <div class="inputsWrap">
          <el-input v-model="chooseGood.address" maxlength="30" placeholder="请输入收货地址"></el-input>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="conBtn"
        :disabled="zring"
        type="primary"
        style="color:#fff"
        @click="revokeConfirm"
      >确认</el-button>
      <el-button
        class="canelBtn"
        @click="cancleDialog"
      >取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
/*global http util*/
import protocolSS from '../protocol/protocolSS'
export default {
  props: {
    type: { // 1是铺货  2是选货
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      dialogVisible: false,
      chooseGood: {
        commodityId: null,
        bsFlag: null,
        quantity: null,
        name: null,
        cellphone: null,
        address: null
      },
      maxApplyNum: 0, // 可申请数量
      bsFlagsOptions: [
        {
          value: 'B',
          label: '买'
        },
        {
          value: 'S',
          label: '卖'
        }
      ],
      zring: false,
      spreadGoodsId: null
    }
  },
  computed: {
    commodityOptions() {
      return this.$store.state.hqData.marketDetails
    }
  },
  methods: {
    changeQuantity(val) {
      val = val.replace(/[^\d]/g, '') // 清除"数字"和"."以外的字符
      this.chooseGood.quantity = val // 在进行赋值
    },
    // 通过持仓汇总查询可申请数量  铺货查持仓  选货查方向传反方向
    getCanApplyNum() {
      if (this.type === 1) { // 铺货
        if (this.chooseGood.commodityId && this.chooseGood.bsFlag) {
          const parms = JSON.parse(JSON.stringify(protocolSS.param_queryUserPositionSummaries))
          parms.data.page = 0
          parms.data.size = 1
          parms.data.bsFlag = this.chooseGood.bsFlag
          parms.data.commodityId = this.chooseGood.commodityId
          http.gPost(parms).then(response => {
            if (response.data.code != 0) {
              this.$message({ message: response.data.message })
            }
            if (response.data) {
              if (response.data && response.data.code == '0') {
                const resluts = response.data.value.content
                this.maxApplyNum = resluts.length > 0 ? Number(util.floatSub(util.floatSub(resluts[0].quantity, resluts[0].frozeQuantity), resluts[0].optimizeQuantity)) : 0
              }
            }
          })
        }
      } else {
        // 选货
      }
    },
    showDialog(row) {
      if (row) {
        this.spreadGoodsId = row.spreadGoodsId
        this.maxApplyNum = row.sellQuantity
        this.chooseGood = {
          commodityId: String(row.commodityId),
          bsFlag: row.bsFlag === 'B' ? 'S' : 'B',
          quantity: null
        }
      } else {
        this.chooseGood = {
          commodityId: null,
          bsFlag: null,
          quantity: null,
          name: null,
          cellphone: null,
          address: null
        }
        this.spreadGoodsId = null
        this.maxApplyNum = 0
      }
      this.dialogVisible = true
    },
    isEmpty(param) {
      if (param === null || param === undefined || param === '') {
        return true
      } else {
        return false
      }
    },
    cancleDialog() {
      this.chooseGood = {
        commodityId: null,
        bsFlag: null,
        quantity: null,
        name: null,
        cellphone: null,
        address: null
      }
      this.dialogVisible = false
    },
    revokeConfirm() {
      const that = this
      if (this.isEmpty(this.chooseGood.commodityId)) {
        return this.$message('请选择交易品种')
      } else if (this.isEmpty(this.chooseGood.bsFlag)) {
        return this.$message('请选择交易方向')
      } else if (this.isEmpty(this.chooseGood.quantity)) {
        return this.$message('请输入申请数量')
      } else if (this.chooseGood.quantity <= 0) {
        this.$message('申请数量需大于0')
        return
      } else if (this.chooseGood.quantity > this.maxApplyNum) {
        this.$message('超过可申请数量' + this.maxApplyNum)
        return
      } else if (!this.chooseGood.name) {
        this.$message('请输入收货人')
        this.popupBtn = false
        return
      } else if (!util.isCNName(this.chooseGood.name)) {
        this.$message('请输入正确的收货人')
        this.popupBtn = false
        return
      } else if (!this.chooseGood.cellphone) {
        this.$message('请输入联系电话')
        this.popupBtn = false
        return
      } else if (!util.isPoneAvailable(this.chooseGood.cellphone)) {
        this.$message('请输入11位联系电话')
        this.popupBtn = false
        return
      } else if (!this.chooseGood.address) {
        this.$message('请输入收货地址')
        this.popupBtn = false
        return
      }
      this.zring = true
      this.$confirm('确定后，持仓立即交收转化为仓单并提货，请确认是否申请交收并提货操作？', {
          customClass: 'blackMessage',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
        }).then(() => {
          let newProtol
          if (this.type === 1) {
            newProtol = protocolSS.param_spreadGoods // 铺货
            newProtol.param.name = this.chooseGood.name
            newProtol.param.cellphone = this.chooseGood.cellphone
            newProtol.param.address = this.chooseGood.address
          } else if (this.type === 2) {
            newProtol = protocolSS.param_selectionGoods // 选货
            newProtol.param.spreadGoodsId = this.spreadGoodsId
          }
          newProtol.param.commodityId = this.chooseGood.commodityId
          newProtol.param.quantity = this.chooseGood.quantity
          newProtol.param.bsFlag = this.chooseGood.bsFlag
          http.postFront1(newProtol).then(response => {
            this.zring = false
            if (response.data) {
              const { code, message } = response.data
              if (code == '0') {
                this.$message('成功')
                this.chooseGood.commodityId = ''
                this.chooseGood.bsFlag = ''
                this.chooseGood.quantity = ''
                this.chooseGood.name = ''
                this.chooseGood.cellphone = ''
                this.chooseGood.address = ''
                this.dialogVisible = false
                setTimeout(() => {
                  that.$emit('getData')
                }, window.g.Interface_latency_Time && 800)
              } else {
                this.$message(message)
              }
            }
          })
        }).catch(() => {
          this.zring = false
          this.dialogVisible = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
